<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

// null é "não há medida" (runtime fora do ar, nenhuma amostra), não zero. Mostrar
// 0 ali seria afirmar uma medição que não houve. O "sem dado" é bloco: dentro de um
// número grande, inline, ele herdaria a altura de linha do text-2xl.
const props = defineProps({
  value: { type: Number, default: null },
  format: { type: Function, default: value => String(value) },
  reason: { type: String, default: '' },
});

const { t } = useI18n();

const hasValue = computed(() => typeof props.value === 'number');

const noDataLabel = computed(() =>
  props.reason
    ? t('ANALYTICS_REPORTS.NO_DATA_WITH_REASON', { reason: props.reason })
    : t('ANALYTICS_REPORTS.NO_DATA')
);
</script>

<template>
  <span>
    <template v-if="hasValue">{{ format(value) }}</template>
    <span v-else class="block text-sm font-normal text-n-slate-10">
      {{ noDataLabel }}
    </span>
  </span>
</template>
